import { enTranslations } from '@translations/en';
import { ltTranslations } from '@translations/lt';
import { ruTranslations } from '@translations/ru';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: enTranslations,
        },
        lt: {
            translation: ltTranslations,
        },
        ru: {
            translation: ruTranslations,
        },
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
});

export default i18n;
